module.exports = __webpack_public_path__ + "kustom-side-image.6f52b99dbb6f7172ecfe8888f99dd63a.png";